import React, { Component } from "react";
import moment from "moment";
import { Cancel } from "@material-ui/icons";
import { StyledToggleSelect, DeleteWrapper, OuterWrapper, NoteWrapper, DateWrapper, ContactWrapper } from './StandAloneNotesItemStyles';


const buttonOptions = [
  { name: "Public", index: 0 },
  { name: "Internal", index: 1 },
];

export class StandAloneNotesItem extends Component {


  setIsPrivate(isPrivate) {
    this.props.note.isPrivate = isPrivate;
    this.props.updateNote(this.props.note);
  }

  getPrivateToggle() {
    if (!this.props.authentication.isGuest) {
      const index = this.props.note.isPrivate ? 1 : 0;
      return (
        <StyledToggleSelect
          isPrivate={this.props.note.isPrivate}
          options={buttonOptions}
          onChange={() => this.setIsPrivate(!this.props.note.isPrivate)}
          defaultIndex={index}
        />);
    }
  }

  getDeleteButton = () => {
    return (!this.props.authentication.isGuest || this.props.note.userId === this.props.authentication.user.id)
      && <Cancel onClick={() => this.onRemove()} />
  }

  onRemove = () => this.props.onRemove(this.props.note);

  render() {
    return (
      <OuterWrapper isPrivate={this.props.note.isPrivate} style={{background:`${this.props.note.isPrivate ? "rgb(255 255 255)":"rgb(250, 212, 206)"}`}}>
        <div className="item-header">
          <DeleteWrapper>{this.getDeleteButton()}</DeleteWrapper>
          <ContactWrapper>{!this.props.note.contact ? "N/A" : this.props.note.contact.fullName}</ContactWrapper>
          <DateWrapper>{moment(this.props.note.updatedAt).format("MMMM D, YYYY h:mm A")}</DateWrapper>
        </div>
        <div className="item-content">
          <NoteWrapper>{this.props.note.note}</NoteWrapper>
        </div>
        <div className="item-actions">
          {this.getPrivateToggle()}
        </div>
      </OuterWrapper>
    );
  }
}
